import React from 'react';
import PropTypes from 'prop-types';

export default function ActivityCard({ activitiesForProperty }) {
  return (
    <div className="dashboard-card dashboard-card-full d-flex flex-column">
      <h3 className="d-title activity-underline">Activity</h3>
      <div className="overflow-scroll">
        {activitiesForProperty.map((activity, index) => (
          <div className="d-flex justify-content-between py-3 activity-underline" key={index}>
            <span>{activity.label}</span>
            <span className="ml-4">{activity.date}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

ActivityCard.propTypes = {
  activitiesForProperty: PropTypes.array.isRequired
};
